import { pdf } from '@react-pdf/renderer';
import type {
  Nullish,
  UndecoratedPractice,
  UndecoratedUser,
} from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import type { PdfNode, TraceabilityData } from './types';

export const classes = {
  dialog: 'w-[98vw] max-w-[1000px] min-w-[350px]',
  input: 'w-full mb-8',
  section: 'w-full py-3',
  selectDropdown: 'w-full',
  title: 'mb-4',
  body: 'pt-0 pb-8 w-full min-h-0 overflow-auto flex gap-8',
  button: 'mr-4',
};

export function buildInitialData(
  user: UndecoratedUser | Nullish,
  practice: UndecoratedPractice | Nullish,
  patient: UndecoratedUser | Nullish
): TraceabilityData {
  return {
    expiryDate: '',
    manufactureDate: '',
    resinName: '',
    lotNumber: '',
    patientCode: patient ? formatUserName(patient) : '',
    orderNumber: '',
    orderDescription: '',
    clinicName: practice?.name || '',
    address: practice ? formatAddress(practice) : '',
    ownerName: user ? formatUserName(user) : '',
  };
}
function formatAddress(practice: UndecoratedPractice) {
  return `${practice.addressLine1} ${practice.addressLine2 ? `, ${practice.addressLine2}` : ''}, ${practice.addressLocality}, ${practice.addressPostalCode} ${practice.addressRegion}, ${practice.addressCountryCode}`;
}

export async function buildPdfFile(pdfNode: PdfNode) {
  const blob = await pdf(pdfNode).toBlob();
  return new File([blob], `Traceability Record.pdf`, {
    type: blob.type,
  });
}
